/*
 * Copyright (c) 2020.
 * Simon
 */

import {
    HEAR_DETAIL_REQUEST,
    HEAR_DETAIL_SUCCESS,
    HEAR_DETAIL_FAILURE,
} from '../../../types';

/**
 * @param {*} state
 * @param {*} action
 */
const FanpageHearsModalReducer = (state = {}, action) => {
    switch (action.type) {
        case HEAR_DETAIL_REQUEST:
        case HEAR_DETAIL_SUCCESS:
        case HEAR_DETAIL_FAILURE:
            return {
                ...state,
                data: action.payload
            };
        default:
            return state;
    }
};

export {
    FanpageHearsModalReducer
}